
import { Separator } from "@/components/ui/separator";
import { ApiKeyGenerator } from "./ApiKeyGenerator";

export const ConfigurePluginSection = () => {
  return (
    <div className="space-y-2">
      <h3 className="text-lg font-medium">2. Configure the Plugin</h3>
      <p className="text-gray-500 text-sm">
        After installation, go to Settings &rarr; Website Backup in your WordPress admin area.
      </p>
      <ApiKeyGenerator />
    </div>
  );
};
